
export const Error = () => {
  return (
    <div>Error</div>
  );
};